var styles = {
  "Truncate": "Polaris-Truncate"
};

export { styles as default };
